module.exports = __webpack_public_path__ + "img/added-service-unit-08.e70191a2.png";